export default "__VITE_ASSET__BoRG1dym__"